import { Component, ViewChild, AfterViewInit, OnInit, DoCheck } from '@angular/core';
import { SecureComponent } from './secure/secure.component';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ScrollPanel } from 'primeng/scrollpanel';
import { AppServiceManager } from '../common/services/appServiceManager';
import { DataService } from "./shared/data.service";
import { IRole } from './shared/Domains/role';
import { IMember } from './shared/Domains/member';
import { MemberService } from 'common/services/member.service';
import { Subscription, forkJoin, from, of } from 'rxjs';
import { catchError, concatMap, map, toArray } from 'rxjs/operators';
import { AuthService } from 'common/services/auth.service';
import { IUser } from './shared/Domains/IUser';
import { Configuration } from 'config/config';
import { IPackageBuider } from "app/shared/Domains/packageBuilder";
import { LanguageService } from 'app/LanguageService/Language.Service';
import { IBranch } from './shared/Domains/branch';
import { AppUtils } from 'common/services/app.util';
@Component({
    selector: 'app-rightpanel',
    templateUrl:'./app.rightpanel.component.html'
})
export class AppRightpanelComponent implements AfterViewInit, OnInit, DoCheck {
    @ViewChild('scrollRightPanel') rightPanelMenuScrollerViewChild: ScrollPanel;
    dateCheck: any;
    members: any[];
    sourceMembers: any[];
    allDues: any[] = [];
    subscriptionDues: any[] = [];
    sourceSubscriptionDues: any[] = [];
    trainers: any[];
    sourceTrainers: any[];
    name: any;
    subscriptionSearch = '';
    loading: boolean;
    subscriptionLoading = false;
    check: any;
    memeberSetting: boolean = true;
    role: IRole;
    subscription: Subscription;
    packages: IPackageBuider[] = [];
    user: IUser;
    from: any;
    to: any;
    subscriptionFrom: any = null;
    subscriptionTo: any = null;
    private duesRequestId = 0;
    private panelWasOpen = false;
    imgPreview: boolean = false;
    imgPreviewImg: any;
    whatsAppCommunityLink: any;
    whatsAppCommunityLinkMessage: any;
    branch: IBranch;

    constructor(
        private LanguageService: LanguageService,
        public config: Configuration,
        private service: MemberService,
        private dataService: DataService,
        private confirmationService: ConfirmationService,
        public app: SecureComponent,
        private appServicemanager: AppServiceManager,
        private messageService: MessageService,
        private appServiceManager: AppServiceManager) { }

    ngOnInit() {
        this.role = AuthService.getLoggedInRole();
        if (this.role.name === "Admin" || this.role.name === "Super Admin"|| this.role.name === "Operator") {
            this.memeberSetting = false;
        } else {
            this.memeberSetting = true;
        }
        this.dateCheck = new Date();
        this.members = [];
        this.sourceMembers = [];
        this.allDues = [];
        this.subscriptionDues = [];
        this.sourceSubscriptionDues = [];
        this.from = null;
        this.to = null;
        this.subscriptionFrom = null;
        this.subscriptionTo = null;
        this.trainers = [];
        this.sourceTrainers = [];
        this.getAllTrainersNotifications();
        this.getAllMembersNotifications();
        this.refreshSubscriptionDues();
        this.getPackages();
        this.getBranchById();
        this.service.events$.forEach(event => {
            if (event == 'defaulterRefreshclicked!') {
                this.getAllMembersNotifications();
            }
        });
        this.dataService.currentRefreshDefaulters.subscribe((currentData) => {
            if (currentData === "refreshDefaulters") {
                this.getAllMembersNotifications();
                this.getAllTrainersNotifications();
            }
        })
    }
	setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("AppRightpanelComponent", label);
      }
    // ngDoCheck(){
    //     console.log("DO CHECK")
    // }

    ngAfterViewInit() {
        setTimeout(() => { this.rightPanelMenuScrollerViewChild.moveBar(); }, 100);
    }

    ngDoCheck() {
        const isOpen = !!this.app?.rightPanelActive;
        if (isOpen && !this.panelWasOpen) {
            this.subscriptionFrom = null;
            this.subscriptionTo = null;
            this.subscriptionSearch = '';
            if (this.allDues.length) {
                this.filterSubscriptionDuesByDate();
            } else if (!this.subscriptionLoading) {
                this.loadAllSubscriptionDues();
            }
        }
        this.panelWasOpen = isOpen;
    }
    openWhatsApp(member): string {

        let reciever = member.contact;
        if (member.contact) {

            let date = new Date(member.createdDate);
            let month = date.getMonth() + 1; // Adding 1 because getMonth() returns zero-based index
            let expiryDate = date.toLocaleString('en-GB', { day: 'numeric', month: 'short' }); // e.g. 10 Sep
            let year = date.getFullYear();
            let url = `branches/${AuthService.getLoggedInBranch()}/customers/actions/defaulters-message-count`;
            this.appServicemanager.post(url, { tagNumber: member.tagNumber }).subscribe(
                (res: any) => {
                    this.getDefaulters();
                },
                (error: any) => {
                    this.messageService.clear();
                    this.messageService.add({ severity: "error", summary: "Error Message", detail: error, });
                }
            );
            let sessionData = localStorage.getItem('currentCompany');
            let parsedData = JSON.parse(sessionData);
            let name = parsedData.name;
            let msg = this.config.expiredFeeReminderMessage;
            if(this.role.branch == "651a591aae5ff029ba201bd6"){
                msg = this.config.jackedfeesMessage;
            }
            msg = msg.replace("{0}", member.name);
            msg = msg.replace("{1}", member.customerId);
            msg = msg.replace("{2}", month.toString());
            msg = msg.split("{3}").join(year.toString());
            msg = msg.replace("{4}", this.user.company);
            msg = msg.replace("{5}", this.user.branch);
            msg = msg.replace("{6}", expiryDate);
            msg = msg.replace("{7}", name);
            msg = msg.replace("{8}", "false");
            const paymentToken = AppUtils.encodePublicQueryToken({
                memberid: member.customerId,
                month: month,
                year: year,
                company: this.user.company,
                branch: this.user.branch,
                isRegistration: false,
            });
            msg = msg.replace("{10}", paymentToken);

            if(this.whatsAppCommunityLink){
                msg = msg.replace("{9}", this.whatsAppCommunityLinkMessage);
            }else{
                msg = msg.replace("{9}", "");
            }
            const message = encodeURIComponent(msg);

                const link = document.createElement('a');
                link.href = `https://wa.me/${reciever}?text=${message}`;
                link.target = '_blank';
                link.click();
                return '';
        } else {
            // Show error message here
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: 'This user does not have a phone number',
            });
            return '';
        }
    }

    openSubscriptionWhatsApp(member) {
        const receiver = member?.contact || member?.contactNumber;
        if (!receiver) {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: 'This user does not have a phone number',
            });
            return;
        }
        const branchId = AuthService.getLoggedInBranch() || this.user?.branch;
        this.appServiceManager
            .post(`branches/${branchId}/customers/actions/subscription-defaulters-message-count`, {
                tagNumber: member?.tagNumber,
            })
            .subscribe(
                () => {
                    this.loadAllSubscriptionDues();
                },
                (error: any) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error Message',
                        detail: error,
                    });
                }
            );
        const memberName = member?.name || 'Member';
        const membershipNo = member?.tagNumber || '';
        const service = member?.serviceName || '';
        const trainer = member?.trainerName || member?.trainer?.name || '';
        const dueDate = member?.defaulterDate || member?.dueDate;
        const dueDateText = dueDate
            ? new Date(dueDate).toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
            })
            : '';
        const branchName = (this.branch?.name || '').trim();
        const gender = (member?.gender || '').toString().toUpperCase();
        const title = gender === 'F' ? 'Ms. ' : gender === 'M' ? 'Mr. ' : '';
        const club = branchName || 'our club';
        const lines = [
            `Dear ${title}${memberName},`,
            '',
            `This is a kind reminder from ${club} regarding your expired membership subscription.`,
            '',
            'Membership Details:',
        ];
        if (service) {
            lines.push(`• Service: ${service}`);
        }
        if (trainer) {
            lines.push(`• Trainer: ${trainer}`);
        }
        if (membershipNo) {
            lines.push(`• Membership No.: ${membershipNo}`);
        }
        if (dueDateText) {
            lines.push(`• Expiry Date: ${dueDateText}`);
        }
        lines.push(
            '',
            'We kindly request you to renew your subscription at your earliest convenience to continue enjoying our services without interruption.',
            '',
            'If you require any assistance regarding the renewal process, please feel free to contact our reception team.',
            '',
            `Thank you for being a valued member of ${club}.`,
            '',
            'Best regards,',
            club
        );
        const msg = lines.join('\n');
        const link = document.createElement('a');
        link.href = `https://wa.me/${receiver}?text=${encodeURIComponent(msg)}`;
        link.target = '_blank';
        link.click();
    }
    getAllMembersNotifications() {
        this.from = '';
        this.to = '';
        this.name = '';
        this.user = AuthService.getLoggedInUser();
        this.members = [];
        this.loading = true;
        this.getDefaulters();
    }

    getDefaulters() {
        this.user = AuthService.getLoggedInUser();
        this.loading = true;
        let url: any;
        if (this.from && this.to) {
            let fromDate = new Date(this.from);
            let toDate = new Date(this.to);
            let data = {
                from: fromDate.getFullYear() + "-" + ("0" + (fromDate.getMonth() + 1)).slice(-2) + "-" + ("0" + fromDate.getDate()).slice(-2),
                to: toDate.getFullYear() + "-" + ("0" + (toDate.getMonth() + 1)).slice(-2) + "-" + ("0" + toDate.getDate()).slice(-2),
            };
            url = `branches/${this.user.branch}/customers/reports/defaulters?from=${data.from}&to=${data.to}`;
        } else {
            url = `branches/${this.user.branch}/customers/reports/defaulters`;
        }
        if (this.from <= this.to) {
            this.appServicemanager.get(url).subscribe(async (res: any) => {
                this.members = [];
                if (res !== null && res.length > 0) {
                    this.members = res;
                    this.loading = false;
                    this.sourceMembers = res;
                    this.members.forEach(async member => {
                        if (!member.messageCount) {
                            member.messageCount = 0;
                        }
                    });
                    this.members = this.members.sort((a, b) => { return <any>new Date(b.defaulterDate) - <any>new Date(a.defaulterDate) });
                    await this.updateMemberFees();
                } else {
                    this.loading = false;
                }
                this.dataService.changeLength(this.members.length);
            },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
                });
        } else {
            if (this.to) {
                this.loading = false;
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'From Date is greater than To Date' });
            }
        }
    }

    refreshSubscriptionDues() {
        this.subscriptionFrom = null;
        this.subscriptionTo = null;
        this.subscriptionSearch = '';
        this.user = AuthService.getLoggedInUser();
        this.subscriptionDues = [];
        this.sourceSubscriptionDues = [];
        this.allDues = [];
        this.loadAllSubscriptionDues();
    }

    clearSubscriptionFromDate() {
        this.subscriptionFrom = null;
        this.filterSubscriptionDuesByDate();
    }

    clearSubscriptionToDate() {
        this.subscriptionTo = null;
        this.filterSubscriptionDuesByDate();
    }

    filterSubscriptionDuesByDate() {
        if (this.subscriptionFrom && this.subscriptionTo && this.startOfDay(this.subscriptionFrom) > this.startOfDay(this.subscriptionTo)) {
            this.subscriptionLoading = false;
            this.messageService.clear();
            this.messageService.add({
                severity: 'info',
                summary: 'Info Message',
                detail: 'From Date is greater than To Date',
            });
            return;
        }
        this.loadAllSubscriptionDues();
    }

    private loadAllSubscriptionDues() {
        const branchId = AuthService.getLoggedInBranch() || this.user?.branch;
        if (!branchId) {
            this.subscriptionLoading = false;
            return;
        }
        this.subscriptionLoading = true;
        const requestId = ++this.duesRequestId;
        const data = {
            from: this.formatDuesDate(this.subscriptionFrom) || '2000-01-01',
            to: this.formatDuesDate(this.subscriptionTo) || '2099-12-31',
        };
        this.appServiceManager
            .post(`branches/${branchId}/subscriptions/reports/defaulter`, data)
            .subscribe(
                (res: any) => {
                    if (requestId !== this.duesRequestId) {
                        return;
                    }
                    const payload = res?.response ?? res;
                    const rows = Array.isArray(payload?.data)
                        ? payload.data
                        : this.asDuesArray(payload);
                    this.applyDuesRows(this.mapApiDuesRows(rows));
                },
                (error: any) => {
                    if (requestId !== this.duesRequestId) {
                        return;
                    }
                    this.subscriptionLoading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error Message',
                        detail: error?.error?.message || error?.message || String(error),
                    });
                }
            );
    }

    private loadDuesHistories(branchId: string, apiRows: any[], requestId: number) {
        const members = this.uniqueDuesMembers(apiRows);
        if (!members.length) {
            this.applyDuesRows([]);
            return;
        }
        forkJoin({
            services: this.appServiceManager.get(`branches/${branchId}/services`).pipe(
                catchError(() => of({ response: [] }))
            ),
            trainers: this.appServiceManager.get(`branches/${branchId}/users/actions/trainers`).pipe(
                catchError(() => of([]))
            ),
        }).subscribe(
            (lookups: any) => {
                if (requestId !== this.duesRequestId) {
                    return;
                }
                this.fetchDuesHistoriesInBatches(
                    branchId,
                    members,
                    this.asDuesArray(lookups?.services),
                    this.asDuesArray(lookups?.trainers),
                    apiRows,
                    requestId
                );
            },
            () => {
                if (requestId !== this.duesRequestId) {
                    return;
                }
                this.fetchDuesHistoriesInBatches(branchId, members, [], [], apiRows, requestId);
            }
        );
    }

    private fetchDuesHistoriesInBatches(
        branchId: string,
        members: any[],
        services: any[],
        trainers: any[],
        apiRows: any[],
        requestId: number
    ) {
        const batchSize = 8;
        const batches: any[][] = [];
        for (let i = 0; i < members.length; i += batchSize) {
            batches.push(members.slice(i, i + batchSize));
        }
        from(batches)
            .pipe(
                concatMap((batch) =>
                    forkJoin(batch.map((member) => this.fetchOneDuesHistory(branchId, member)))
                ),
                toArray()
            )
            .subscribe(
                (batchResults: any[]) => {
                    if (requestId !== this.duesRequestId) {
                        return;
                    }
                    const histories = ([] as any[]).concat(...(batchResults || []));
                    const rows = this.buildDuesRows(histories, services, trainers);
                    this.applyDuesRows(rows.length ? rows : this.mapApiDuesRows(apiRows));
                },
                () => {
                    if (requestId !== this.duesRequestId) {
                        return;
                    }
                    this.applyDuesRows(this.mapApiDuesRows(apiRows));
                }
            );
    }

    private fetchOneDuesHistory(branchId: string, member: any) {
        const memberId = this.duesMemberId(member);
        if (!memberId) {
            return of({ member, subscriptions: [], fees: [] });
        }
        return forkJoin({
            subscriptions: this.appServiceManager
                .get(`branches/${branchId}/subscriptions/members/${memberId}`)
                .pipe(catchError(() => of({ response: [] }))),
            fees: this.appServiceManager
                .get(`branches/${branchId}/subscription-fees/members/${memberId}`)
                .pipe(catchError(() => of({ response: [] }))),
        }).pipe(
            map((res: any) => ({
                member,
                subscriptions: this.asDuesArray(res?.subscriptions),
                fees: this.asDuesArray(res?.fees),
            }))
        );
    }

    private buildDuesRows(histories: any[], services: any[], trainers: any[]): any[] {
        const serviceById = new Map<string, any>(
            (services || []).filter((s) => s?._id).map((s) => [String(s._id), s])
        );
        const trainerById = new Map<string, any>(
            (trainers || []).filter((t) => t?._id).map((t) => [String(t._id), t])
        );
        const rows: any[] = [];
        (histories || []).forEach((history, memberIndex) => {
            const member = history?.member || {};
            const fees = history?.fees || [];
            const subscriptions = (history?.subscriptions || []).filter(
                (sub: any) => sub && sub.isDelete !== true && sub.serviceId !== 'Expired'
            );
            const uniqueSubs = new Map<string, any>();
            subscriptions.forEach((sub: any, subIndex: number) => {
                const key = String(sub?._id || sub?.subscriptionId || `${memberIndex}_${subIndex}`);
                if (!uniqueSubs.has(key)) {
                    uniqueSubs.set(key, sub);
                }
            });
            const memberSubs = Array.from(uniqueSubs.values());
            if (!memberSubs.length) {
                rows.push(...this.mapApiDuesRows([member]));
                return;
            }
            memberSubs.forEach((sub: any) => {
                const fee = fees.find((f: any) => String(f?.subscriptionId) === String(sub?._id)) || {};
                const service = serviceById.get(String(sub?.serviceId || '')) || sub?.service || {};
                const trainer = trainerById.get(String(sub?.trainerId || fee?.trainerId || '')) || sub?.trainer || {};
                rows.push(this.toDuesRow(member, sub, fee, service, trainer));
            });
        });
        return rows;
    }

    private toDuesRow(member: any, sub: any, fee: any, service: any, trainer: any): any {
        const dueDate = sub?.dueDate ?? sub?.endDate ?? sub?.expiryDate ?? member?.defaulterDate;
        return {
            ...member,
            ...sub,
            customerId:
                sub?.subscriberId ??
                member?.customerId ??
                member?.subscriberId ??
                member?.memberId ??
                member?._id,
            name:
                member?.name ??
                member?.customerName ??
                sub?.subscriberName ??
                sub?.customerName ??
                '',
            tagNumber:
                member?.tagNumber ??
                member?.membershipNo ??
                sub?.subscriberMembership ??
                sub?.tagNumber ??
                '',
            profile: member?.profile ?? sub?.profile ?? member?.image,
            gender: member?.gender ?? sub?.gender,
            contact:
                member?.contact ??
                member?.contactNumber ??
                member?.mobile ??
                sub?.contact ??
                sub?.contactNumber ??
                '',
            fee: fee?.pay ?? sub?.pay ?? sub?.fee ?? member?.fee ?? 0,
            defaulterDate: dueDate,
            dueDate,
            startDate: sub?.startDate ?? member?.startDate,
            serviceName: sub?.serviceName || service?.name || sub?.name || '',
            trainerName: sub?.trainerName || trainer?.name || '',
            subscriptionId: sub?._id ?? sub?.subscriptionId,
            messageCount: Number(sub?.subscriptionDefaulterMessageCount ?? member?.subscriptionDefaulterMessageCount ?? sub?.messageCount ?? member?.messageCount) || 0,
        };
    }

    private mapApiDuesRows(rows: any[]): any[] {
        return (rows || []).map((row) =>
            this.toDuesRow(row, row, row, row?.service || {}, row?.trainer || {})
        );
    }

    private applyDuesRows(rows: any[]) {
        this.allDues = (rows || [])
            .map((row) => {
                if (row && row.messageCount == null) {
                    row.messageCount = Number(row.subscriptionDefaulterMessageCount) || 0;
                }
                return row;
            })
            .sort((a, b) => {
                return <any>new Date(b?.defaulterDate || b?.dueDate) - <any>new Date(a?.defaulterDate || a?.dueDate);
            });
        this.subscriptionLoading = false;
        this.sourceSubscriptionDues = this.allDues;
        if (this.subscriptionSearch) {
            this.searchSubscriptionLocal(this.subscriptionSearch);
        } else {
            this.subscriptionDues = [...this.allDues];
        }
    }

    private formatDuesDate(value: any): string | null {
        if (value == null || value === '') {
            return null;
        }
        const date = new Date(value);
        if (isNaN(date.getTime())) {
            return null;
        }
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        return date.getFullYear() + '-' + month + '-' + day;
    }

    private filterRowsByExpiry(rows: any[]): any[] {
        const fromDate = this.subscriptionFrom ? this.startOfDay(this.subscriptionFrom) : null;
        const toDate = this.subscriptionTo ? this.startOfDay(this.subscriptionTo) : null;
        if (!fromDate && !toDate) {
            return [...(rows || [])];
        }
        return (rows || []).filter((row) => {
            const expiry = this.startOfDay(
                row?.defaulterDate ?? row?.dueDate ?? row?.endDate ?? row?.expiryDate
            );
            if (!expiry) {
                return false;
            }
            if (fromDate && expiry < fromDate) {
                return false;
            }
            if (toDate && expiry > toDate) {
                return false;
            }
            return true;
        });
    }

    private startOfDay(value: any): Date | null {
        if (value == null || value === '') {
            return null;
        }
        const d = new Date(value);
        if (isNaN(d.getTime())) {
            return null;
        }
        d.setHours(0, 0, 0, 0);
        return d;
    }

    private asDuesArray(value: any): any[] {
        if (Array.isArray(value)) {
            return value;
        }
        if (Array.isArray(value?.response)) {
            return value.response;
        }
        if (Array.isArray(value?.data)) {
            return value.data;
        }
        return [];
    }

    private duesMemberId(row: any): string {
        return String(
            row?.subscriberId ??
                row?.customerId ??
                row?.memberId ??
                row?.customer?._id ??
                row?.member?._id ??
                row?._id ??
                ''
        );
    }

    private uniqueDuesMembers(rows: any[]): any[] {
        const unique = new Map<string, any>();
        (rows || []).forEach((row) => {
            const id = this.duesMemberId(row);
            if (!id || unique.has(id)) {
                return;
            }
            unique.set(id, row);
        });
        return Array.from(unique.values());
    }

    getBranchById() {
        this.loading = true;
        this.branch = AuthService.getLoggedInCurrentBranch();
        if(this.branch){
            this.whatsAppCommunityLink = this.branch.whatsappCommunityInvitationLink;
            this.whatsAppCommunityLinkMessage = "\n\nWe also have a vibrant WhatsApp community where our members share tips, motivation, and support each other's fitness journeys. If you'd like to join this community, simply tap on this link\n" + this.whatsAppCommunityLink;
        }
        if(!this.branch){
        this.appServiceManager.get('branches/' + AuthService.getLoggedInBranch()).subscribe((res) => {
            if (res) {
                this.whatsAppCommunityLink = res.whatsappCommunityInvitationLink;
                this.whatsAppCommunityLinkMessage = "\n\nWe also have a vibrant WhatsApp community where our members share tips, motivation, and support each other's fitness journeys. If you'd like to join this community, simply tap on this link\n" + this.whatsAppCommunityLink;
            } else {
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Records Found' });
            }
            this.loading = false;
        },
            (error) => {
                this.loading = false;
                this.messageService.clear();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
        }
    }

    getPackages() {
        this.packages = [];
        this.loading = true;
        this.appServiceManager
            .get(
                "branches/" +
                this.user.branch +
                "/package-builders"
            )
            .subscribe(
                (res: IPackageBuider[]) => {
                    this.packages = res;
                    this.loading = false;
                },
                (error: any) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }

    async updateMemberFees() {
        for (const member of this.members) {
            if (member.packageId) {
                const packageInfo = this.packages.find(p => p._id === member.packageId);
                if (packageInfo) {
                    member.fee = packageInfo.packageFee;
                }
            }
        }
    }

    openPhoto(imgUri, gender) {
        this.imgPreview = true;
        if (!imgUri) {
        if (gender == 'F')
            this.imgPreviewImg = 'avatarGirlImage.png';

        } else {

        const isGirlAvatar = imgUri === 'avatarGirlImage.png';

        if (isGirlAvatar) {
            this.imgPreviewImg = 'avatarGirlImage.png';
        } else {
            this.imgPreviewImg = imgUri;
        }
        }
    }
    closePhotoPreview() {
        this.imgPreview = false;
        this.imgPreviewImg = "";
    }

    getAllTrainersNotifications() {
        this.members = [];
        this.loading = true;
        this.user = AuthService.getLoggedInUser();
        //this.getTrainersDefaulters();
        // this.appServicemanager.get("customers/trainerNotifications/company/" + this.user.company + '/branch/' + this.user.branch).subscribe((res: any) => {
        //     this.getTrainersDefaulters();
        //     this.loading = false;
        // },
        //     (error) => {
        //         this.loading = false;
        //         this.messageService.clear();
        //         this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        //     });
    }
    // getTrainersDefaulters() {
    //     this.loading = true;
    //     this.appServicemanager.get("customers/trainerDefaulters/company/" + this.user.company + '/branch/' + this.user.branch).subscribe((res: any) => {
    //         this.trainers = [];
    //         if (res !== null && res.length > 0) {
    //             this.trainers = res;
    //             this.loading = false;
    //             this.sourceTrainers = res;
    //             this.trainers = this.trainers.sort((a, b) => { return <any>new Date(b.defaulterDate) - <any>new Date(a.defaulterDate) });
    //         } else {
    //             this.messageService.clear();
    //             // this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Records Found' });
    //             this.loading = false;
    //         }
    //         this.dataService.changeTrainerLength(this.trainers.length);
    //     },
    //         (error) => {
    //             this.loading = false;
    //             this.messageService.clear();
    //             this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
    //         });
    // }
    searchLocal(value) {
        let matchedName = [];
        let matchedTagNumber = [];
        let matchedContact = [];
        let matchedEmail = [];
        if (value !== null && value !== undefined && value.toString().length > 0) {
            if (value == "") {
                this.members = Object.assign([], this.sourceMembers);
            }
            if (!value) {
                this.members = Object.assign([], this.sourceMembers);
            }
            if (value != "") {
                matchedContact = Object.assign([], this.sourceMembers).filter(
                    cust => cust.tagNumber ? cust.tagNumber.indexOf(value) > -1 : null);

                matchedName = Object.assign([], this.sourceMembers).filter(
                    cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
                const distinct = (value, index, self) => {
                    return self.indexOf(value) === index;
                }
                const source = matchedName.concat(matchedTagNumber, matchedContact, matchedEmail);
                this.members = source.filter(distinct);

                if (this.members.length === 0) {
                    this.members = [];
                    this.messageService.clear();
                    this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Records Found' });
                } else {
                    this.members = [...this.members];
                }
            }
        } else {
            this.members = Object.assign([], this.sourceMembers);
            this.members = [...this.members];
        }
    }

    searchSubscriptionLocal(value) {
        const source = this.sourceSubscriptionDues || [];
        if (value !== null && value !== undefined && value.toString().length > 0) {
            const query = value.toString().toLowerCase();
            this.subscriptionDues = source.filter((row) => {
                const name = (row?.name || '').toString().toLowerCase();
                const tag = (row?.tagNumber || '').toString().toLowerCase();
                const service = (row?.serviceName || '').toString().toLowerCase();
                return name.indexOf(query) > -1 || tag.indexOf(query) > -1 || service.indexOf(query) > -1;
            });
        } else {
            this.subscriptionDues = [...source];
        }
    }
    searchTrainerLocal(value) {
        let matchedName = [];
        let matchedTagNumber = [];
        let matchedContact = [];
        let matchedEmail = [];
        if (value !== null && value !== undefined && value.toString().length > 0) {
            if (value == "") {
                this.trainers = Object.assign([], this.sourceTrainers);
            }
            if (!value) {
                this.trainers = Object.assign([], this.sourceTrainers);
            }
            if (value != "") {
                matchedContact = Object.assign([], this.sourceTrainers).filter(
                    cust => cust.tagNumber ? cust.tagNumber.indexOf(value) > -1 : null);

                matchedName = Object.assign([], this.sourceTrainers).filter(
                    cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
                const distinct = (value, index, self) => {
                    return self.indexOf(value) === index;
                }
                const source = matchedName.concat(matchedTagNumber, matchedContact, matchedEmail);
                this.trainers = source.filter(distinct);

                if (this.trainers.length === 0) {
                    this.trainers = [];
                    this.messageService.clear();
                    this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Records Found' });
                } else {
                    this.trainers = [...this.trainers];
                }
            }
        } else {
            this.trainers = Object.assign([], this.sourceTrainers);
            this.trainers = [...this.members];
        }
    }

    deleteDefaulter(defaulter: any) {
        this.confirmationService.confirm({
            message: "Are you sure you want to temporarily remove this member from the defaulter list?",
            accept: () => {
                this.loading = true;
                this.appServicemanager.delete(`branches/${AuthService.getLoggedInBranch()}/customers/${defaulter.customerId}/actions/delete-defaulter`).subscribe((response: any) => {
                    const index: number = this.members.indexOf(defaulter);
                    if (index !== -1) {
                        this.members.splice(index, 1);
                    }
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Defaulter Successfully Deleted' });
                    this.dataService.changeLength(this.members.length);
                    this.dataService.refreshDefaulter
                }, (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
                })
            }
        })
    }
    deleteTrainerDefaulter(mem: IMember) {
        this.confirmationService.confirm({
            message: "Are you sure you want to temporarily remove this member from the defaulter list?",
            accept: () => {
                this.loading = true;
                this.appServicemanager.delete(`branches/${AuthService.getLoggedInBranch()}/customers/${mem._id}/actions/delete-trainer-defaulter`).subscribe((response: any) => {
                    const index: number = this.members.indexOf(mem);
                    if (index !== -1) {
                        this.members.splice(index, 1);
                    }
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Defaulter Successfully Deleted' });
                    this.dataService.changeTrainerLength(this.trainers.length);
                }, (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
                })
            }
        })
    }

}
